import React from 'react'
import { Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ControlSplit } from '@fs/zion-icon'
import { useR2DispatchContext, useR2StateContext } from '../../../../../providers/r2Provider/R2Context'
import { useSharedBrowserStateContext } from '../../../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

export default function SplitScreenToggle() {
  const r2State = useR2StateContext()
  const sharedBrowserState = useSharedBrowserStateContext()
  const r2Dispatch = useR2DispatchContext()
  const [t] = useTranslation()

  const toggleSplitScreen = () => {
    if (r2State.splitScreen) {
      r2Dispatch({
        type: 'SET_SPLIT_SCREEN',
        value: false,
      })
    } else {
      r2Dispatch({
        type: 'SET_SPLIT_SCREEN',
        value: true,
      })
      r2Dispatch({
        type: 'SET_REFERENCE_FOCUSED_INDEX',
        value: sharedBrowserState.focusedIndex,
      })
      r2Dispatch({
        type: 'SET_SPLIT_SCREEN_IMAGE_GRID',
        value: true,
      })
    }
  }

  return (
    <Button Icon={ControlSplit} onClick={toggleSplitScreen} data-testid="splitScreenToggle">
      {r2State.splitScreen
        ? t('edit-relationships.close-split-screen', 'Close split-screen')
        : t('edit-relationships.open-split-screen', 'Open split-screen')}
    </Button>
  )
}
